const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterBottle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.723,
    height: 420.775,
    viewBox: "0 0 38.027 111.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ced3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-37.965a6.449 6.449 0 0 1-6.45-6.447v-19.482H6.449v19.482A6.448 6.448 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 25.71 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a9b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "M107.245 71.182H89.303v-3.697h17.942z",
    transform: "translate(-79.26 -61.418)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afdce0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v-6.023c0-1.11.592-2.136 1.552-2.69l1.972-1.138a3.099 3.099 0 0 0 1.553-2.687v-31.48a3.103 3.103 0 0 0-1.553-2.689l-1.972-1.137A3.106 3.106 0 0 1 0-50.533v-6.024c0-1.108.592-2.133 1.552-2.688l1.972-1.137a3.106 3.106 0 0 0 1.553-2.687v-31.482c0-1.11-.592-2.134-1.553-2.687l-1.972-1.138A3.106 3.106 0 0 1 0-101.063v-6.026c0-1.107.592-2.134 1.552-2.687l1.972-1.138a3.106 3.106 0 0 0 1.553-2.69v-25.242c0-7.43-6.024-13.454-13.454-13.454h-80.884c-7.43 0-13.454 6.024-13.454 13.454v25.242c0 1.111.592 2.134 1.553 2.69l1.972 1.138a3.104 3.104 0 0 1 1.552 2.687v6.026a3.106 3.106 0 0 1-1.552 2.687l-1.972 1.138a3.099 3.099 0 0 0-1.553 2.687v31.482c0 1.107.592 2.131 1.553 2.687l1.972 1.137a3.106 3.106 0 0 1 1.552 2.688v6.024a3.106 3.106 0 0 1-1.552 2.689l-1.972 1.137a3.103 3.103 0 0 0-1.553 2.689v31.48c0 1.11.592 2.134 1.553 2.687l1.972 1.138a3.106 3.106 0 0 1 1.552 2.69V0c0 1.11-.592 2.134-1.552 2.688l-1.972 1.137a3.106 3.106 0 0 0-1.553 2.69c0 29.149 6.135 57.984 18.121 84.553.039.096.078.182.118.271a257.258 257.258 0 0 0 9.31 18.529 10.847 10.847 0 0 1 1.389 5.297v17.215a.033.033 0 0 1-.031.031h-1.163c-1.729 0-3.288 1.259-3.443 2.982a3.279 3.279 0 0 0 3.271 3.578h52.492c1.73 0 3.283-1.267 3.429-2.989a3.28 3.28 0 0 0-3.265-3.571h-1.342a.033.033 0 0 1-.031-.031v-17.215c0-1.853.489-3.678 1.389-5.297a257.77 257.77 0 0 0 9.317-18.529c.04-.089.078-.175.118-.271C-1.05 64.499 5.077 35.664 5.077 6.515a3.106 3.106 0 0 0-1.553-2.69L1.552 2.688A3.103 3.103 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 36.236 57.602)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008ca2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v-31.481a.728.728 0 0 0-.362-.63l-1.975-1.14a5.5 5.5 0 0 1-2.74-4.745v-6.023a5.483 5.483 0 0 1 2.74-4.739l1.975-1.136A.748.748 0 0 0 0-50.533v-31.48a.734.734 0 0 0-.362-.632l-1.975-1.137a5.502 5.502 0 0 1-2.74-4.745v-6.026a5.483 5.483 0 0 1 2.74-4.737l1.975-1.135a.75.75 0 0 0 .362-.64v-25.243c0-6.111-4.974-11.088-11.084-11.088h-80.884c-6.112 0-11.086 4.977-11.086 11.088v25.243c0 .268.142.504.372.64l1.974 1.135a5.488 5.488 0 0 1 2.73 4.737v6.026a5.508 5.508 0 0 1-2.73 4.745l-1.974 1.137a.722.722 0 0 0-.372.632v31.48c0 .267.142.505.372.639l1.974 1.136a5.488 5.488 0 0 1 2.73 4.739v6.023a5.506 5.506 0 0 1-2.73 4.745l-1.974 1.14a.717.717 0 0 0-.372.63V0c0 .267.142.505.372.639l1.974 1.136a5.485 5.485 0 0 1 2.73 4.738v6.023a5.507 5.507 0 0 1-2.73 4.747l-1.974 1.136a.723.723 0 0 0-.372.632c0 21.28 3.214 42.028 9.594 61.942h83.867C-3.213 61.071 0 40.331 0 19.051a.735.735 0 0 0-.362-.632l-1.975-1.136a5.502 5.502 0 0 1-2.74-4.747V6.513a5.48 5.48 0 0 1 2.74-4.738L-.362.639A.748.748 0 0 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 37.19 62.026)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a9b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 3.196-18.803 5.786-41.999 5.786-23.194 0-41.998-2.59-41.998-5.786 0-3.197 18.804-5.789 41.998-5.789C-18.803-5.789 0-3.197 0 0",
    transform: "matrix(.35278 0 0 -.35278 33.852 33.453)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBottle);
export default __webpack_public_path__ + "static/media/water_bottle.1d444dc10c30fd5a8c38b58fb58acc84.svg";
export { ForwardRef as ReactComponent };